/// <reference types="@types/googlemaps" />
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Inject,
  Injectable,
  PLATFORM_ID,
} from '@angular/core';

import {
  BehaviorSubject,
  Subject,
} from 'rxjs';
import {
  apiRequest,
  ServiceBase,
} from 'services';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends ServiceBase {
  TRAVELDOCS: Subject<any>;
  UPDATETRAVELDOCS: Subject<any>;
  DELTRAVELDOCS: Subject<any>;
  GETTRAVELDOCS: BehaviorSubject<any>
  GETFRQTRAVELACCTS: BehaviorSubject<any>
  POSTFREQACC: Subject<any>;
  UPDATEFREQACC: Subject<any>;
  DELFREQACC: Subject<any>;
  GETUSERADDRESS: BehaviorSubject<any>;
  SETCUSTOMER: BehaviorSubject<any>;
  UPDATEADDRESS: Subject<any>;
  DELADDRESS: Subject<any>;
  POSTCUSTOMER: Subject<any>;
  POSTCUSTOMERPERDTLS: Subject<any>;
  GETEMERGENCYDTLS: BehaviorSubject<any>;
  POSTEMERGENCY: Subject<any>;
  UPDATEEMERGENSYDTLS: Subject<any>;
  DELEMDTLS: Subject<any>;
  geocoder: google.maps.Geocoder;
  GETUSERSUBSCRIBEDMAPPINGDETAILSSUCCESS: Subject<any>;
  UPDATEUSERSUBSCRIBINGMAPPINGDETAILSSUCCESS: Subject<any>;
  ALLSUBSCRIPTIONDETAILSSUCCESS: Subject<any>;
  GETEMERGENCYDTLSBYUSERID: BehaviorSubject<any>;
  constructor(http: HttpClient, @Inject(PLATFORM_ID) private platformId) {
    super(http);
    this.ALLSUBSCRIPTIONDETAILSSUCCESS = new Subject<any>();
    this.GETUSERSUBSCRIBEDMAPPINGDETAILSSUCCESS = new Subject<any>();
    this.UPDATEUSERSUBSCRIBINGMAPPINGDETAILSSUCCESS = new Subject<any>();
    this.GETEMERGENCYDTLSBYUSERID = new BehaviorSubject<any>(undefined);
    this.TRAVELDOCS = new Subject<any>();
    this.UPDATETRAVELDOCS = new Subject<any>()
    this.DELTRAVELDOCS = new Subject<any>()
    this.GETTRAVELDOCS = new BehaviorSubject<any>(undefined);
    this.GETFRQTRAVELACCTS = new BehaviorSubject<any>(undefined)
    this.POSTFREQACC = new Subject<any>()
    this.UPDATEFREQACC = new Subject<any>()
    this.DELFREQACC = new Subject<any>()
    this.GETUSERADDRESS = new BehaviorSubject<any>(undefined)
    this.SETCUSTOMER = new BehaviorSubject<any>(undefined)
    this.UPDATEADDRESS = new Subject<any>()
    this.DELADDRESS = new Subject<any>()
    this.POSTCUSTOMER = new Subject<any>()
    this.POSTCUSTOMERPERDTLS = new Subject<any>()
    this.GETEMERGENCYDTLS = new BehaviorSubject<any>(undefined)
    this.POSTEMERGENCY = new Subject<any>()
    this.UPDATEEMERGENSYDTLS = new Subject<any>()
    this.DELEMDTLS = new Subject<any>()
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      this.geocoder = new google.maps.Geocoder()
    }

  }

  posttraveldocs(data) {
    this.post<any>({ url: 'Common/UserTravelDocumentDetails/v1/InsertUserTravelDocumentDetails', data: data, onNotify: this.TRAVELDOCS } as apiRequest<any>);
  }

  updatetraveldocs(data) {
    this.post<any>({ url: 'Common/UserTravelDocumentDetails/v1/UpdateUserTravelDocumentDetails', data: data, onNotify: this.UPDATETRAVELDOCS } as apiRequest<any>);
  }

  deletetraveldocs(data) {
    this.post<any>({ url: 'Common/UserTravelDocumentDetails/v1/DeleteUserTravelDocumentDetails', data: data, onNotify: this.DELTRAVELDOCS } as apiRequest<any>);
  }

  gettraveldocs(data) {
    this.post<any>({ url: 'Common/UserTravelDocumentDetails/v1/UserTravelDocumentDetailsGetByUserid', data: data, onNotify: this.GETTRAVELDOCS } as apiRequest<any>);
  }

  getfreqtraveldtls(data) {
    this.post<any>({ url: 'Common/UserFrequentTravellerDetails/v1/UserFrequentTravellerDetailsGetByUserid', data: data, onNotify: this.GETFRQTRAVELACCTS } as apiRequest<any>);
  }

  postfreqtravelacct(data) {
    this.post<any>({ url: 'Common/UserFrequentTravellerDetails/v1/InsertUserFrequentTravellerDetails', data: data, onNotify: this.POSTFREQACC } as apiRequest<any>);
  }
  updatefreqtravelacct(data) {
    this.post<any>({ url: 'Common/UserFrequentTravellerDetails/v1/EditUserFrequentTravellerDetails', data: data, onNotify: this.UPDATEFREQACC } as apiRequest<any>);
  }

  deletefreqtravelacct(data) {
    this.post<any>({ url: 'Common/UserFrequentTravellerDetails/v1/DeleteUserFrequentTravellerDetails', data: data, onNotify: this.DELFREQACC } as apiRequest<any>);
  }

  //personal info

  getaddressbyuseid(data) {
    this.post<any>({ url: 'Common/UserAddress/v1/GetUserAddressByUserId', data: data, onNotify: this.GETUSERADDRESS } as apiRequest<any>);
  }

  updateaddressdtls(data) {
    this.post<any>({ url: 'Common/UserAddress/v1/EditUserAddress', data: data, onNotify: this.UPDATEADDRESS } as apiRequest<any>);
  }

  deleteaddressdtls(data) {
    this.post<any>({ url: 'Common/UserAddress/v1/DeleteUserAddress', data: data, onNotify: this.DELADDRESS } as apiRequest<any>);
  }

  postcustomeraddressdtls(data) {
    this.post<any>({ url: 'Common/UserAddress/v1/InsertUserAddress', data: data, onNotify: this.POSTCUSTOMER } as apiRequest<any>);
  }

  setcustomerdtls(data) {
    this.post<any>({ url: 'Login/YTBB2CCustomer/v1/YTBB2CCustomerGetByUserid', data: data, onNotify: this.SETCUSTOMER } as apiRequest<any>);
  }

  getEmergencyDetailsByUserId(data) {
    this.post<any>({ url: 'Common/EmergencyContact/v1/GetByUserid', data: data, onNotify: this.GETEMERGENCYDTLSBYUSERID } as apiRequest<any>);
  }

  getallemergencydtls(data) {
    this.post<any>({ url: 'Common/ContactDetails/v1/GetByContactDetails', data: data, onNotify: this.GETEMERGENCYDTLS } as apiRequest<any>);
  }

  postemergencydtls(data) {
    this.post<any>({ url: 'Common/ContactDetails/v1/InsertContactDetails', data: data, onNotify: this.POSTEMERGENCY } as apiRequest<any>);
  }

  updateemergencydtls(data) {
    this.post<any>({ url: 'Common/ContactDetails/v1/UpdateContactDetails', data: data, onNotify: this.UPDATEEMERGENSYDTLS } as apiRequest<any>);
  }

  deleteemergencydtls(data) {
    this.post<any>({ url: 'Common/ContactDetails/v1/DeleteContactDetails', data: data, onNotify: this.DELEMDTLS } as apiRequest<any>);
  }

  updatecustomerdtls(data) {
    this.post<any>({ url: 'Login/YTBB2CCustomer/v1/YTBB2CCustomerUpdate', data: data, onNotify: this.POSTCUSTOMERPERDTLS } as apiRequest<any>);
  }

  getEmailSubscriptionMappingforEmail(data) {
    this.post<any>({ url: 'Common/EmailSubscription/v1/GetSubscriptionMappingByEmail', data: data, onNotify: this.GETUSERSUBSCRIBEDMAPPINGDETAILSSUCCESS } as apiRequest<any>);
  }


  updateEmailSubscriptionMappingforEmail(data) {
    this.post<any>({ url: 'Common/EmailSubscription/v1/UpdateUserSubscriptionMappingForEmail', data: data, onNotify: this.UPDATEUSERSUBSCRIBINGMAPPINGDETAILSSUCCESS } as apiRequest<any>);
  }


  getAllSubscriptionTypes() {
    this.get<any>({ url: 'Common/EmailSubscriptionType/v1/GetAllEmailSubscriptionTypes', onNotify: this.ALLSUBSCRIPTIONDETAILSSUCCESS } as apiRequest<any>);
  }


}
